export var secureStorageAddresses = [
    { address: '0x5fbFd001C9571BDFd8995f3ABb385C07E7A53150', chainId: 1 },
    { address: '0xB2017BA31D3dC97910b8F44d3F5BfaCeE0BD2a6B', chainId: 10 },
    { address: '0xA17aC61C3888c15D09d641Be62DdEA0809108A6f', chainId: 42161 },
    { address: '0x30B25912faeb6E9B70c1FD9F395D2fF2083C966C', chainId: 8453 },
    { address: '0xCb1788C494EAa23A89836d977066d3016C8E14fC', chainId: 11155111 },
];
export var secureStorageAddressFrom = {
    '1': '0x5fbFd001C9571BDFd8995f3ABb385C07E7A53150',
    '10': '0xB2017BA31D3dC97910b8F44d3F5BfaCeE0BD2a6B',
    '42161': '0xA17aC61C3888c15D09d641Be62DdEA0809108A6f',
    '8453': '0x30B25912faeb6E9B70c1FD9F395D2fF2083C966C',
    '11155111': '0xCb1788C494EAa23A89836d977066d3016C8E14fC',
};
